import { Query, CoughAnalysisSet } from "./api/apiTypes";

const _storage = sessionStorage;

const verifySessionStorageSupport = () => {
    var testKey = (+new Date).toString();
    var testVal = (+new Date).toString();
    try {
        if (!_storage) { throw ""; }
        _storage.setItem(testKey, testVal);
        if (_storage.getItem(testKey) !== testVal) { throw ""; }
        _storage.removeItem(testKey);
    } catch (e) {
        throw new Error("HTML5 Session Storage is unsupported or not implement properly on the current browser.");
    }
    };

verifySessionStorageSupport();

const _getCoughAnalysisQueryCacheKey = () => "CoughAnalysisQueryTable";

export const getCachedCoughAnalysisQuery = () =>
    JSON.parse(_storage.getItem(_getCoughAnalysisQueryCacheKey())) as Query<CoughAnalysisSet>;

export const setCachedCoughAnalysisQuery = (cachedQuery: Query<CoughAnalysisSet>) => {
    _storage.setItem(_getCoughAnalysisQueryCacheKey(), JSON.stringify(cachedQuery));
    return cachedQuery;
};
